import { Activity } from '../activity'
import { Item } from '../item'

import { Template } from './template'

export default new Template({
  description:
    'Applying rules to RATE records, calculating pools, allocating and generating reports',
  id: Template.Id.RatePrepareProposal,
  name: 'RATE Prepare Proposal',
  steps: [
    {
      withoutItems: {
        description: 'Applying rules to the RATE records',
        name: 'Applying rules',
        type: Activity.Type.RateRefreshGlRecords,
      },
    },
    {
      withoutItems: {
        description: 'Writing data to the DMS',
        name: 'Writing to DMS',
        type: Activity.Type.RateWriteGlRecordsToDms,
      },
    },
    {
      basedOnItems: items => {
        const type = Activity.Type.RateCalculatePools
        const steps = items
          .filter(item => item.type === Item.Type.Pool)
          .map(item => ({
            description: `Calculating ${item.name} pool`,
            item,
            name: `Calculating ${item.name} pool`,
            type,
          }))
        return steps.length
          ? steps
          : [
              // Placeholder
              {
                description: 'Calculating RATE pools',
                item: undefined,
                name: 'Calculating pools',
                type,
              },
            ]
      },
    },
    {
      basedOnItems: items => {
        const type = Activity.Type.RateCalculateAllocations
        const steps = items
          .filter(item => item.type === Item.Type.Allocation)
          .map(item => ({
            description: `Calculating ${item.name} allocation`,
            item,
            name: `Calculating ${item.name} allocation`,
            type,
          }))
        return steps.length
          ? steps
          : [
              // Placeholder
              {
                description: 'Calculating RATE allocations',
                item: undefined,
                name: 'Calculating allocations',
                type,
              },
            ]
      },
    },
    {
      basedOnItems: items => {
        const type = Activity.Type.RateGenerateReportContent
        const steps = items
          .filter(item => item.type === Item.Type.Report)
          .map(item => ({
            description: `Generating and storing ${item.name} report content`,
            item,
            name: `Generating ${item.name} report`,
            type,
          }))
        return steps.length
          ? steps
          : [
              // Placeholder
              {
                description: 'Generating and storing reports content',
                item: undefined,
                name: 'Generating reports content',
                type,
              },
            ]
      },
    },
  ],
})
